// eslint-disable-next-line @typescript-eslint/no-explicit-any
type I18n = any
type SaveType = "save" | "remove" | "update" | "execute"

export async function useExplicitSave(
  createSnackbar: (snackbar: Snackbar) => Snackbar,
  $i18n: I18n,
  f: () => Promise<unknown>,
  type: SaveType = "save",
) {
  const getMessages = (type: SaveType): { savingMessage: string; savedMessage: string; saveFailedMessage: string } => {
    switch (type) {
      case "save":
        return { savingMessage: "saving", savedMessage: "saved", saveFailedMessage: "saveFailed" }
      case "remove":
        return { savingMessage: "removing", savedMessage: "removed", saveFailedMessage: "removeFailed" }
      case "update":
        return { savingMessage: "updating", savedMessage: "updated", saveFailedMessage: "updateFailed" }
      case "execute":
        return { savingMessage: "executing", savedMessage: "executed", saveFailedMessage: "executeFailed" }
    }
  }

  const { savingMessage, savedMessage, saveFailedMessage } = getMessages(type)

  // Show the snackbar to the user
  const snackbar = createSnackbar({
    title: $i18n.t(savingMessage),
    type: "info",
    timeout: -1,
    closable: false,
    pending: true,
  })

  try {
    // Executes the function
    const caption = await f()

    // Updates the existing snackbar
    snackbar.title = $i18n.t(savedMessage)
    snackbar.type = type === "remove" ? "info" : "success"
    snackbar.timeout = 3000
    snackbar.text = caption ? String(caption) : ""
    snackbar.closable = true
    snackbar.pending = false

    return true
  } catch (e) {
    const errorMessage = getErrorMessage(e)
    console.error(errorMessage)
    const scopes = typeof e === "object" && e !== null && "scopes" in e ? e.scopes : null
    const translatedErrorMessage = $i18n.te(`errorMessages.${errorMessage}`) ? $i18n.t(`errorMessages.${errorMessage}`) : errorMessage

    snackbar.title = $i18n.t(saveFailedMessage)
    snackbar.type = "error"
    snackbar.timeout = 3000
    snackbar.text = `${scopes ?? ""} ${translatedErrorMessage}`
    snackbar.closable = true
    snackbar.pending = false

    return false
  }
}
